import React from 'react';
import { shape, func, object, oneOfType } from 'prop-types';

import { Coachmark } from '@ajaibid/components';

const CACHE_KEY = 'stock_coachmark_step';

const CoachmarkStock = (props) => {
  const { refs } = props;

  const coachmarks = [
    {
      title: 'Dapatkan hingga 5x Buying Power Dengan Day Trading',
      // description: 'Dapatkan hingga 5x Buying Power Dengan Day Trading',
      reference: refs.stockPopupBuy,
      position: 'top',
      prerequisite: !!refs.stockPopupBuy,
    },
    {
      title: 'Makin mudah berpindah saham',
      description:
        'Saat Anda membuka tab baru, halaman Tab Baru yang dipersonalisasi berdasarkan histori penjelajahan akan muncul.',
      actionText: 'Mengerti',
      reference: refs.tickerTabs,
      position: 'bottom',
    },
    {
      title: 'Akses Cepat Dashboard Order',
      description:
        'Kini kamu bisa pantau, ubah, atau batalkan order Reksa Dana dan Saham yang berjalan. Selain itu, akses juga riwayat transaksi dari dashboard ini, kapanpun kamu butuhkan.',
      actionText: 'Mengerti',
      reference: refs.bottomPanel,
      position: 'top-left',
    },
    {
      title: 'Atur Tampilan Dashboard Order',
      description: 'Perbesar atau kecilkan tampilan dashboard order sesuai kebutuhan kamu.',
      actionText: 'Mengerti',
      reference: refs.bottomPanel,
      position: 'top-right',
    },
  ];

  return <Coachmark cacheKey={CACHE_KEY} list={coachmarks} show />;
};

CoachmarkStock.propTypes = {
  refs: shape({
    stockPopupBuy: oneOfType([func, shape({ current: object })]),
    tickerTabs: oneOfType([func, shape({ current: object })]),
    bottomPanel: oneOfType([func, shape({ current: object })]),
  }).isRequired,
};

export default CoachmarkStock;
